export default __webpack_public_path__ + "static/OurTeamBgImg-aecb62065e7c02d54bbf812b78a438c3.webp";